import { lazy } from 'react';

export const ShippinginfoPage = lazy(() => import('./page-list'));
